import { render, staticRenderFns } from "./ForumEvent.vue?vue&type=template&id=0b7232f6&scoped=true"
import script from "./ForumEvent.vue?vue&type=script&lang=ts"
export * from "./ForumEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7232f6",
  null
  
)

export default component.exports